import { CONTRACT_SERVICE } from "@/store/constants";

const WORKFLOWS = "/workflows"

const workflowIcon = {
  'cronDateAction': 'mdi-calendar-sync',
  'fixedDateAction': 'mdi-calendar',
  'relativeDateAction': 'mdi-calendar-expand-horizontal',
}

export default {
  namespaced: true,
  actions: {
    getWorkflowTypes ({ dispatch }, { target }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(WORKFLOWS + '/triggers/' + encodeURIComponent(target)))
        .then(result => (result.data.items.map(item => ({ ...item, icon: workflowIcon[item.name] }))))
    },
    getWorkflowNames ({ dispatch }, { workflow }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
          .then(api => api.get(WORKFLOWS + '/names?workflow=' + encodeURIComponent(workflow)))
          .then(result => (result.data.items))
    },
    getWorkflows ({ dispatch }, { target }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(WORKFLOWS + '/targets/' + encodeURIComponent(target)))
        .then(result => (result.data.items))
    },
    getWorkflow ({ dispatch }, { target, id }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.get(WORKFLOWS + '/' + encodeURIComponent(target) + '/' + encodeURIComponent(id)))
        .then(result => (result.data))
    },
    saveWorkflow ({ dispatch }, { data }) {
      const id = data.id
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => {
          if (id) {
            return api.put(WORKFLOWS + '/' + encodeURIComponent(id), data)
          } else {
            return api.post(WORKFLOWS, data)
          }
        })
        .then(result => (result.data))
    },
    deleteWorkflow ({ dispatch }, { id }) {
      return dispatch('API', CONTRACT_SERVICE, { root: true })
        .then(api => api.delete(WORKFLOWS + '/' + encodeURIComponent(id)))
        .then(result => (result.data))
    },
  },
  getters: {},
  mutations: {},
  state: {}
}
